import { routes } from '~/shared/constants/routes';
import { createUrlWithSearchParams } from '~/shared/lib/searchParams';

interface PayoutTradersSearchParams {
    traderName?: string;
    bankAccountId?: string;
}

const payoutTradersSearchParamNames = {
    mode: 'mode',
    traderName: 'traderName',
    bankAccountId: 'bank_accsount_id',
} as const;

export const createPayoutTradersUrl = ({ traderName, bankAccountId }: PayoutTradersSearchParams = {}) => {
    return createUrlWithSearchParams(
        routes.traders,
        {
            mode: 'payout',
            traderName,
            bankAccountId,
        },
        payoutTradersSearchParamNames,
    );
};
